import MessengerContainer from "../../Components/Messenger";

const Messenger = () => {
  return <MessengerContainer />;
};

export default Messenger;
